enum ERoute {
  PATH_ROOT = '/',
  PATH_HOME = '/home',
  PATH_CONVERSATIONS = '/conversations',
  PATH_NEW_CONVERSATION = '/conversations/new',
  PATH_CONVERSATION = '/conversations/:id',
  PATH_HELP = '/help',
  PATH_HELP_COLLECTION = '/help/collections/:id',
  PATH_ARTICLE = '/help/articles/:id',
  PATH_NEWS_OVERVIEW = '/news',
  PATH_NEWS = '/news/:id'
}

export default ERoute